import { useGetCurrentAdditionalUserQuantity, useGetCurrentTotalUserSeats } from './use-get-additional-users-count-for-promo-plan';
import { useGetCurrentBillingPlanWithFallbacks } from '../../../../../../hooks/use-get-current-billing-plan-with-fallbacks';
import { getPlanTotalPrice } from '../helpers';

/** @typedef {import('../types.d.ts').PlanDetails} PlanDetails */
/** @typedef {import('../types.d.ts').Price} Price */

/**
 * If the base plan price is not a number type then we are certain that we'd show a bad current card.
 * @param {Price} pricePerPeriod
 * @returns {boolean}
 */
const didWeCalculateFromIncompleteBillingPlan = (pricePerPeriod) => !Number.isFinite(pricePerPeriod?.value);

/**
 * @returns {PlanDetails}
 */
export const useGetCurrentPlanDetails = () => {
  const currentUserSeatCount = useGetCurrentTotalUserSeats();
  const currentAdditionalUserQuantity = useGetCurrentAdditionalUserQuantity();

  const currentBillingPlan = useGetCurrentBillingPlanWithFallbacks();
  const { name, pricePerPeriod, shipmentLimit, userAddOnPrice, userLimit } = currentBillingPlan;

  const updatedUserLimit = {
    ...userLimit,
    limit: currentUserSeatCount,
  };

  const totalPlanPrice = getPlanTotalPrice({
    basePlanPrice: pricePerPeriod,
    shipmentLimitPrice: 0, // user has no shipment volume addOn because they're on an old plan
    additionalUserCount: currentAdditionalUserQuantity,
    additionalUserPrice: userAddOnPrice?.value,
    legacyLineItemAddOnsPrice: 0, // todo: add this if you can verify that it's what the other approach does
  });

  return {
    name,
    pricePerMonth: totalPlanPrice,
    userLimit: updatedUserLimit,
    shipmentLimit,
    shouldHideCard: didWeCalculateFromIncompleteBillingPlan(pricePerPeriod),
  };
};
